import React from 'react'

import ExamplesGrid from '../../Examples/components/ExamplesGrid/ExamplesGrid'
import examples from '../../Landing/UseCases/examples.json'

import styles from './ExamplesSection.module.css'

const ExamplesSection = ({ history }) => {
  return (
    <div>
      <div className={`${styles.container} m-auto`}>
        <h1 className="white font-60 bold">We're tiiny but mighty</h1>
        <p className={`${styles.subtitle} font-20`}>
          You can use tiiny to share over 100 different types of documents, files or projects online.
        </p>
        <ExamplesGrid examples={examples} history={history} darkMode />
      </div>
    </div>
  )
}
export default ExamplesSection
